import React from "react";
import { Payload, Record } from "../types";

type Props = {
  state: Payload<Record>;
}

const Summary: React.FC<Props> = props => {
  if (props.state.file === null) {
    return null;
  }

  return (
    <div>
      <table className="table table-bordered">
        <tbody>
          <tr>
            <td>
              <strong>Filename</strong>
            </td>
            <td>{props.state.file.name}</td>
          </tr>
          <tr>
            <td>
              <strong>Number of records</strong>
            </td>
            <td>{props.state.data.length}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Summary;
